var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('nav-bar'),_c('modal-component'),_c('router-view',{key:_vm.$route.fullPath}),_c('floating-button',{attrs:{"text":"Enjoying Project42?"}}),_c('footer-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }